import dedent from 'ts-dedent'
import {
  ColumnDataType,
  GetOutputSchemaParams,
  Provider,
  TableSchema,
  WorkflowComponentCodeParams,
  WorkflowComponentParamType
} from '../types'
import { addColumn } from '../utils/schemas'
import { SelectWorkflowComponent } from './common/selectcomponent'

class GeometryType extends SelectWorkflowComponent {
  constructor() {
    super(
      {
        name: 'native.geometrytype',
        group: 'Spatial Accessors',
        title: 'ST Geometry Type',
        description: `
      This component adds a column containing
      the geography type of the geography in each row of the input table.
      `
      },
      [
        {
          name: 'source',
          type: WorkflowComponentParamType.InputTable,
          title: 'Source table'
        },
        {
          name: 'geo',
          type: WorkflowComponentParamType.Column,
          title: 'Geo column',
          parent: 'source',
          dataType: [ColumnDataType.Geography, ColumnDataType.Geometry]
        }
      ]
    )
  }

  getInnerSql({ params, connection }: WorkflowComponentCodeParams) {
    switch (connection.type) {
      case Provider.BigQuery:
      case Provider.Postgres:
      case Provider.Redshift:
        return dedent`SELECT *, ST_GEOMETRYTYPE(${connection.processInputGeogColumn(params.geo as string)})
                  AS ${params.geo}_geomtype
                FROM ${connection.quoteName(params.source as string)}`
      case Provider.DatabricksRest:
        return dedent`SELECT /*+ REPARTITION(40) */
                  *, ST_GEOMETRYTYPE(${connection.processInputGeogColumn(params.geo as string)})
                  AS ${params.geo}_geomtype
                FROM ${connection.quoteName(params.source as string)}`
      case Provider.Snowflake:
        return dedent`SELECT *,
                  CONCAT('ST_',
                    SPLIT_PART(
                      ST_ASTEXT(${params.geo}), '(', 0)
                    )
                    AS ${params.geo}_geomtype
                  FROM ${connection.quoteName(params.source as string)}`
      case Provider.Oracle: {
        const geoColumn = params.geo as string
        const geomTypeColumn = `${params.geo}_geomtype`
        return dedent`SELECT t.*,
                  CASE t.${geoColumn}.SDO_GTYPE
                    WHEN 2001 THEN 'ST_POINT'
                    WHEN 2002 THEN 'ST_LINESTRING'
                    WHEN 2003 THEN 'ST_POLYGON'
                    WHEN 2004 THEN 'ST_MULTIPOINT'
                    WHEN 2005 THEN 'ST_MULTILINESTRING'
                    WHEN 2006 THEN 'ST_MULTIPOLYGON'
                    WHEN 2007 THEN 'ST_GEOMETRYCOLLECTION'
                    ELSE 'ST_GEOMETRY'
                  END AS ${geomTypeColumn}
                FROM ${connection.quoteName(params.source as string)} t`
      }
      default:
        return null
    }
  }

  canProvideOutputSchemas(): boolean {
    return true
  }

  getOutputSchema({ columns, params }: GetOutputSchemaParams): TableSchema {
    return addColumn(columns.source, {
      name: `${params.geo}_geomtype` as string,
      type: ColumnDataType.String
    })
  }
  supportedProviders(): Provider[] {
    return [
      Provider.BigQuery,
      Provider.Postgres,
      Provider.Redshift,
      Provider.Snowflake,
      Provider.DatabricksRest,
      Provider.Oracle
    ]
  }
}

export { GeometryType }
